import { useAuth } from './use-auth.js';

export type StaffRole = 'owner' | 'manager' | 'cashier' | 'washer';

/**
 * The signed-in person's role at their current tenant, from the `roles` claim
 * (`{ [tenantId]: role }`). Null for a super-admin with no tenant role, or
 * while auth resolves.
 *
 * The server and the security rules are the real gate; this only decides what
 * a screen SHOWS — and for the floor that matters a great deal. Most carwash
 * washers are foreign workers who may read none of the app's four languages,
 * so a washer's screen is built from symbols, colour and numbers, not menus
 * and words (owner, 2026-10-16).
 */
export function useMyRole(): StaffRole | null {
  const { claims } = useAuth();
  const tenantId = typeof claims?.['defaultTenant'] === 'string' ? claims['defaultTenant'] : null;
  const roles = (claims?.['roles'] ?? {}) as Record<string, unknown>;
  const role = tenantId ? roles[tenantId] : undefined;
  return role === 'owner' || role === 'manager' || role === 'cashier' || role === 'washer'
    ? role
    : null;
}

/** Washers and cashiers work the floor: their chrome is the job, nothing else. */
export function isFloorRole(role: StaffRole | null): boolean {
  return role === 'washer' || role === 'cashier';
}
